import React from "react";

/**
 * BOF-76 — when the figures on screen were last computed (FR-055).
 *
 * The period's `computedAt` is the oldest of its days' — a fold is only as fresh as its least fresh
 * input — so this never overstates how current the numbers are.
 */
const DataFreshness: React.FC<{ computedAt: string | null }> = ({ computedAt }) => {
  const when = computedAt
    ? new Date(computedAt).toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Europe/Berlin",
      })
    : null;
  return (
    <span className="text-xs text-color-secondary">
      <i className="pi pi-clock mr-1" style={{ fontSize: "0.75rem" }} aria-hidden />
      {when ? `Figures computed ${when} (Berlin)` : "Computation time not recorded"} · complete days only
    </span>
  );
};

export default DataFreshness;
